var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { sprintf } from 'sprintf-js';
import classNames from 'classnames';
import { Typography, Button } from "../../index";
import { ChevronLeft, ChevronRight } from "../../icons/index";
import { makeStyles } from "../../styles/index";
import { useTranslation } from "../../hooks/useTranslation";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        flex: '0 0 auto',
        // inline時にページングの状態によってページャーの幅が変わらないように nn / mm 時の幅(2桁ページまでを想定)を最低幅として固定する
        minWidth: 195,
        // ボタンのスタイルの上書き
        // デフォルトでついているスタイルの詳細度が高いためrootの下で定義する。
        '& $pagerButton': {
            borderRadius: theme.spacing(3),
            color: theme.palette.light.text.primary,
            minWidth: 48,
            padding: 0,
            margin: theme.spacing(0, 1),
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
                color: theme.palette.text.primary,
            },
            '&:active': {
                backgroundColor: theme.palette.action.active,
            },
            '&:disabled': {
                opacity: 0,
            },
        },
    },
    barRoot: {
        flex: '1',
    },
    display: {
        flex: '1',
        userSelect: 'none',
    },
    pagerButton: {},
    barPagerButton: {
        flex: '1',
    },
}); }, { name: 'SnPagination' });
/**
 * ページネーションのコンポーネント。
 *
 * - 現在ページの確認。
 * - ページ送りを行うためのもの。
 * - 表示要素が0の時はページネーション自体を非表示とする。
 */
export var Pagination = function (props) {
    var _a, _b;
    // 型定義的には`others`に要素は1つもないが、UiKitを利用するプロジェクトで付与されるカスタムデータ属性を引き渡すために`others`を使用している。
    var page = props.page, lastPage = props.lastPage, onChange = props.onChange, _c = props.variant, variant = _c === void 0 ? 'inline' : _c, others = __rest(props, ["page", "lastPage", "onChange", "variant"]);
    var classes = useStyles();
    var t = useTranslation().t;
    var handleClickPrev = useCallback(function () {
        onChange(page - 1);
    }, [page, onChange]);
    var handleClickNext = useCallback(function () {
        onChange(page + 1);
    }, [page, onChange]);
    var rootClass = classNames(classes.root, (_a = {},
        _a[classes.barRoot] = variant === 'bar',
        _a));
    var pagerButtonClass = classNames(classes.pagerButton, (_b = {},
        _b[classes.barPagerButton] = variant === 'bar',
        _b));
    if (lastPage === 0)
        return null;
    return (React.createElement("div", __assign({ className: rootClass }, others),
        React.createElement(Button, { className: pagerButtonClass, disabled: page <= 1, onClick: handleClickPrev },
            React.createElement(ChevronLeft, null)),
        React.createElement(Typography, { align: "center", variant: "body2", className: classes.display }, sprintf(t('%d / %d'), page, lastPage)),
        React.createElement(Button, { className: pagerButtonClass, disabled: lastPage <= page, onClick: handleClickNext },
            React.createElement(ChevronRight, null))));
};
